import { render, staticRenderFns } from "./OptionalForm.vue?vue&type=template&id=3a473e6d"
import script from "./OptionalForm.vue?vue&type=script&lang=js"
export * from "./OptionalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports